import { RecurringMeetingMapping } from '@/types/RecurringMeetingMapping';
import { queryApi } from '@/utility/queryApi';

export type EditRecurringMeetingAssociationProps = {
  recurringMeetingMapping: RecurringMeetingMapping;
};

export const editRecurringMeetingAssociation = ({
  recurringMeetingMapping,
}: EditRecurringMeetingAssociationProps) =>
  queryApi<RecurringMeetingMapping>({
    body: JSON.stringify(recurringMeetingMapping),
    method: 'PUT',
    path: `/api/recurring-meeting-association/${recurringMeetingMapping.id}`,
  });
